import React from 'react';
import { PlanStep } from './types';
import { groupPlanSteps, planStepLabel, toolShort } from './utils';

function DiagArrow({ small, label, amber }: { small?: boolean; label?: string; amber?: boolean }) {
  const cls = [
    'bx-diag-arrow',
    small ? 'bx-diag-arrow--sm' : '',
    amber ? 'bx-diag-arrow--amber' : '',
  ].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      <div className="bx-diag-arrow-line" />
      {label && <span className="bx-diag-arrow-label">{label}</span>}
      <div className="bx-diag-arrow-head" />
    </div>
  );
}

export default function PlanGraph({ steps }: { steps: PlanStep[] }) {
  const groups = groupPlanSteps(steps);
  return (
    <div className="bx-diag">
      {groups.map((g, gi) => (
        <React.Fragment key={gi}>
          {gi > 0 && <DiagArrow />}
          {g.kind === 'action' ? (
            <div className="bx-diag-node bx-diag-node--action">
              <div className="bx-diag-node-dot" />
              <div className="bx-diag-node-body">
                <span className="bx-diag-node-label">{planStepLabel(g.step)}</span>
                <span className="bx-diag-node-tool">{toolShort(g.step.tool)}</span>
              </div>
            </div>
          ) : (
            <div className="bx-diag-decision">
              {/* Decision node */}
              <div className="bx-diag-node bx-diag-node--check">
                <div className="bx-diag-diamond">◆</div>
                <div className="bx-diag-node-body">
                  <span className="bx-diag-node-label">{planStepLabel(g.check)}</span>
                  <span className="bx-diag-node-tool">{toolShort(g.check.tool)}</span>
                </div>
                {g.branches.length > 0 && (
                  <span className="bx-diag-skip-badge">found → skip</span>
                )}
              </div>
              {/* Conditional branch (if not found) */}
              {g.branches.length > 0 && (
                <>
                  <DiagArrow label="if not found" amber />
                  <div className="bx-diag-branch">
                    {g.branches.map((b, bi) => (
                      <React.Fragment key={b.idx}>
                        {bi > 0 && <DiagArrow small />}
                        <div className="bx-diag-node bx-diag-node--branch">
                          <div className="bx-diag-node-dot bx-diag-node-dot--branch" />
                          <div className="bx-diag-node-body">
                            <span className="bx-diag-node-label">{planStepLabel(b.step)}</span>
                            <span className="bx-diag-node-tool">{toolShort(b.step.tool)}</span>
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                </>
              )}
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
